
import { getIsAdmin } from '../../reducers/mysliveckyportal/permissions';
import useAuthToken from './useAuthToken';
import useUserPermissions from './useUserPermissions';

export default function useAdminPermission(userPermissionsState, projectId) {
    const token = useAuthToken();
    useUserPermissions(userPermissionsState, projectId);
    const isAdmin = getIsAdmin(userPermissionsState);

    let isAdminFinal = null;

    if (token) {
        isAdminFinal = isAdmin;
    } else {
        if (token === '') {
            // stored token does not exist or is invalid
            isAdminFinal = false;
        }
    }

    return isAdminFinal;
}
